import { useState, useEffect, ChangeEvent } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

import { WallForm } from './types';

import { useWall } from 'features/walls/api/getWall';
import { useCreateWall } from './api/createWall';
import { useUpdateWall } from 'features/walls/api/updateWall';

interface Props {
  open: boolean;
  handleClose: () => void;
  selectedWallId: number;
}

const WallEditDialog = ({ open, handleClose, selectedWallId }: Props) => {
  const { data: selectedWall } = useWall({ wallId: selectedWallId });
  const createWallMutation = useCreateWall({});
  const updateWallMutation = useUpdateWall({});

  const [wall, setWall] = useState<WallForm>({
    id: '',
    name: '',
    rows: 1,
    columns: 1,
  });

  const [formErrors, setFormErrors] = useState({
    wallNameFlag: false,
  });

  const handleSubmit = async () => {
    setFormErrors({ ...formErrors, wallNameFlag: !wall.name });
    if (!wall.name) return;

    if (selectedWall?.id === null || selectedWall?.id === undefined) {
      const { id, ...wallNoId } = wall;

      await createWallMutation.mutateAsync({
        data: wallNoId,
      });
    } else {
      await updateWallMutation.mutateAsync({
        data: {
          ...wall,
        },
        wallId: Number(wall.id),
      });
    }
    setWall({ ...wall, id: '', name: '' });
    handleClose();
  };

  const handleCancel = () => {
    setWall({ ...wall, id: '', name: '' });
    handleClose();
  };

  useEffect(() => {
    if (selectedWall === null || selectedWall === undefined) {
      setWall({
        id: '',
        name: '',
        rows: 1,
        columns: 1,
      });
      return;
    }
    setWall((prevState) => ({
      ...prevState,
      id: selectedWall.id,
      name: selectedWall.name,
    }));
  }, [selectedWall]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setWall({
      ...wall,
      [name]: value,
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
      <DialogTitle>
        {selectedWallId > -1 ? 'Edit Wall' : 'New Wall'}
      </DialogTitle>
      <DialogContent>
        <TextField
          id='name'
          label='Wall Name'
          name='name'
          value={wall.name || ''}
          onChange={handleChange}
          margin='dense'
          fullWidth
          required
          error={formErrors.wallNameFlag}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color='secondary' variant='contained'>
          Cancel
        </Button>
        <Button color='primary' onClick={handleSubmit} variant='contained'>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WallEditDialog;
